import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-base/base/templateForm/formPage',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-base/base/templateForm/saveForm',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-base/base/templateForm/formDetail',
  method: 'get',
  params: {
    ...params,
  },
})

const edit = params => request({
  url: '/api/mcc-base/base/templateForm/updateForm',
  method: 'post',
  data: params,
})

const remove = id => request({
  url: '/api/mcc-base/base/templateForm/removeForm',
  method: 'post',
  params: {
    id,
  },
})

const getDeployModel = (current, size, params) => request({
  url: '/api/mcc-base/base-flow-task/getDeployModel',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const newTree = (current, size, params) => request({
  url: '/api/blade-system/role/newTree',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const templateFormProcessSave = params => request({
  url: '/api/mcc-base/product/basetemplateformprocess/save',
  method: 'post',
  data: params,
})

const templateFormProcessEdit = params => request({
  url: '/api/mcc-base/product/basetemplateformprocess/update',
  method: 'post',
  data: params,
})

const templateFormProcessList = (current, size, params) => request({
  url: '/api/mcc-base/product/basetemplateformprocess/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const templateFormProcessRemove = ids => request({
  url: '/api/mcc-base/product/basetemplateformprocess/remove',
  method: 'post',
  params: {
    ids,
  },
})
export default {
  getList,
  add,
  detail,
  edit,
  remove,
  getDeployModel,
  newTree,
  templateFormProcessSave,
  templateFormProcessEdit,
  templateFormProcessList,
  templateFormProcessRemove,
};
